import AuthenticationService from "../../services/Authentication/AuthenticationService";
import { keyAccess } from "../../utils/helpers/helpers";
import { useEffect, useState } from "react";
import { homepageLogin } from "../../services/http-common";

const PrivateRoute = ({ children, allowedRoles }) => {
  const [authorized, setAuthorized] = useState(null); // null = en validación

  useEffect(() => {
    const validateAccess = () => {
      const roles = AuthenticationService.getRoles(); // lee desde access

      const hasAccess = roles && allowedRoles.some((r) => roles.includes(r));

      if (!hasAccess) {
     

        // Redirige de forma forzada para evitar render anticipado
        // window.location.assign(`/${homepageLogin}`);
        setTimeout(() => {
          // Limpia storage
          localStorage.removeItem(keyAccess);
          AuthenticationService.removeToken();
          window.location.assign(`/${homepageLogin}`);
        }, 0);
      } else {
        setAuthorized(true);
      }
    };

    validateAccess();
  }, [allowedRoles]);

  // Mientras validamos, no renderizamos
  if (authorized === null) return null;

  return children;
};

export default PrivateRoute;
